import React, { useMemo, useState } from 'react'
import ReactMde, { getDefaultToolbarCommands, MarkdownUtil } from "react-mde";
import { converter } from "../../constants/sanitize";
import createDOMPurify from "dompurify";


const UNDERLINE = {
    name: "underline",
    keyCommand: "underline",
    icon: () => <span><i className="fas fa-underline" style={{ fontSize: 14 }}/></span>,
    execute: ({ initialState, textApi }) => {

        let newSelectionRange = MarkdownUtil.selectWord({
            text: initialState.text,
            selection: initialState.selection
        });

        let state1 = textApi.setSelectionRange(newSelectionRange);
        let state2 = textApi.replaceSelection("--" + state1.selectedText + "--");

        textApi.setSelectionRange({
            start: state2.selection.end - 2 - state1.selectedText.length,
            end: state2.selection.end - 2
        });
    }
}

const domPurify = createDOMPurify(window || {});
const useDomPurify = () => {
    return useMemo(() => {
        return domPurify;
    }, []);
};

const Editor = ({ className, handleChange, name, label, values, errors, touched }) => {

    let [selectedTab, setSelectedTab] = useState('write');

    let DOM = useDomPurify();

    let isError = errors[name] && touched[name];

    let toolbar = getDefaultToolbarCommands();
    toolbar[0].push("underline");

    return (
        <div className={className ? className : "mb-4"}>
            {label ? <label className="paylixecommerce-label">{label}</label> : null}

            <div className={isError ? "is-invalid" : ""}>
                <ReactMde
                    commands={{
                        "underline": UNDERLINE
                    }}
                    toolbarCommands={toolbar}
                    selectedTab={selectedTab}
                    minEditorHeight={100}
                    value={values[name]}
                    onTabChange={(tab) => setSelectedTab(tab)}
                    onChange={(value) => handleChange(name)(value)}
                    generateMarkdownPreview={(markdown) => Promise.resolve(DOM.sanitize(converter.makeHtml(DOM.sanitize(markdown, { FORBID_TAGS: ["style"] })), { ADD_ATTR: ['target'] }))}
                />
            </div>

            {isError && <div className="invalid-feedback">{errors[name]}</div>}
        </div>
    );
}



export default Editor
